/** @jsxImportSource @emotion/react */

import * as colors from "../styles/colors";
import { Header } from "./Header";

export function Screen({ showHeader = true, children }) {
  return (
    <div
      css={{
        minHeight: "100vh",
        background:
          "linear-gradient(106.45deg, #1D262C 18.83%, rgba(6, 44, 89, 0.79) 109.97%);",
        padding: "1em 0",
      }}
    >
      {showHeader ? <Header /> : null}
      <div css={{ maxWidth: "1200px", margin: "auto", width: "90%" }}>
        {children}
      </div>
    </div>
  );
}

export function TextField({ id, label, textFieldProps, ...props }) {
  return (
    <div
      css={{
        margin: "auto",
        position: "relative",
        color: colors.black,
      }}
      {...props}
    >
      <input
        id={id}
        name={id}
        type="text"
        css={{
          width: "100%",
          fontSize: "1.2em",
          height: "100%",
          padding: "1em",
          paddingTop: "1.2em",
          borderRadius: "0.3em",
          "&::placeholder": {
            color: "transparent",
          },
          "&:focus, &:valid": {
            "&::placeholder": {
              color: colors.black,
            },
            "& + label": {
              top: 0,
              left: "2em",
              fontSize: "0.6em",
              transform: "translateY(50%)",
            },
          },
        }}
        required
        {...textFieldProps}
        {...props}
      />
      <label
        htmlFor={id}
        css={{
          transition: "0.16s",
          position: "absolute",
          top: "50%",
          left: "1em",
          transform: "translateY(-50%)",
          fontSize: "1.2em",
        }}
      >
        {label}
      </label>
    </div>
  );
}
